export type DashboardWidgetScope = {
  label: string;
  description: string;
};

const ALL_TIME_WIDGETS = new Set([
  'performanceByTimeOfDay',
  'performanceByDay',
  'performanceByMonth',
  'profitFactor',
  'maxConsecutiveWins',
  'maxConsecutiveLosses',
  'avgWinLoss',
  'tradePlStandardDeviation',
]);

const WIDGET_TIMEFRAME_WIDGETS = new Set([
  'totalFees',
  'winningVsLosing',
  'totalGainLoss',
  'averageDailyGainLoss',
  'totalCommissions',
  'numberOfWinningTrades',
  'numberOfLosingTrades',
]);

const DASHBOARD_RANGE_WIDGETS = new Set([
  'largestGainLoss',
  'performanceByRelativeVolatility',
  'performanceByVolumeTraded',
  'performanceByEntryAtr',
  'performanceByInTradePriceRange',
  'performanceByDuration',
  'performanceByPrice',
  'performanceByOpeningGap',
  'performanceByVolume',
  'performanceByAtr',
  'performanceByMovement',
  'cumulativePnl',
  'cumulativeDrawdown',
  'averagePerShareGainLoss',
  'largestGain',
  'largestLoss',
  'holdTimeAnalysis',
  'openTrades',
]);

/** Human-readable period scope for Dashboard card headers. */
export function getDashboardWidgetScope(widgetId: string): DashboardWidgetScope | null {
  if (ALL_TIME_WIDGETS.has(widgetId)) {
    return {
      label: 'All-time',
      description: 'Uses all available closed trades, regardless of the Dashboard date range.',
    };
  }

  if (WIDGET_TIMEFRAME_WIDGETS.has(widgetId)) {
    return {
      label: 'Widget range',
      description: 'Uses this widget’s timeframe selector, which follows the Dashboard range unless changed for this widget.',
    };
  }

  if (DASHBOARD_RANGE_WIDGETS.has(widgetId)) {
    return {
      label: 'Dashboard range',
      description: 'Uses the selected Dashboard date range.',
    };
  }

  if (widgetId === 'averageTradePnl' || widgetId === 'dailyVolume') {
    return {
      label: 'Last 7 days',
      description: 'Shows the last seven calendar days, independent of the Dashboard date range.',
    };
  }

  if (widgetId === 'weekSummary') {
    return {
      label: 'Current week',
      description: 'Shows Monday through Sunday for the current local week.',
    };
  }

  if (widgetId === 'longTermInvestments') {
    return {
      label: 'Investment range',
      description: 'Uses the investment widget’s selected horizon and market data.',
    };
  }

  return null;
}
